import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { CircleAlert } from "@/components/icons"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { CourseFeedbackButton } from "@/features/training/components/course-feedback-button"
import { CourseList } from "@/features/training/components/course-list"
import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function ConclusionSummaryPage() {
  const { t } = useTranslation("", { keyPrefix: "training.conclusion.summary" })

  const summaryPoints = t("summary_points", { returnObjects: true }) as string[]
  const nextSteps = t("next_steps.points", { returnObjects: true }) as string[]

  return (
    <CourseLayout>
      <CourseSection>
        <h2>{t("main_title")}</h2>
        <p>{parse(t("description"))}</p>
        <CourseList data={summaryPoints} />
      </CourseSection>
      <CourseSection>
        <h3>{t("next_steps.title")}</h3>
        <CourseList data={nextSteps} />
      </CourseSection>
      <CourseSection>
        <Alert className="border-destructive border">
          <CircleAlert className="text-destructive size-6" />
          <AlertTitle className="text-destructive text-xl font-bold">
            {t("remember_alert_title")}
          </AlertTitle>
          <AlertDescription>
            <p>{t("remember_alert_description")}</p>
          </AlertDescription>
        </Alert>
      </CourseSection>
      <CourseSection>
        <h3>{t("feedback.title")}</h3>
        <p>{parse(t("feedback.description"))}</p>
        <CourseFeedbackButton variant="secondary" />
        <p>{t("feedback.thank_you")}</p>
      </CourseSection>
    </CourseLayout>
  )
}
